import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"
//////////////////////////////////////////////////////////////
//                      ATELIERLIGNEMODELE                  //
//////////////////////////////////////////////////////////////

export const FETCH_ATELIERLIGNEMODELE_BEGIN = "FETCH_ATELIERLIGNEMODELE_BEGIN"
export const FETCH_ATELIERLIGNEMODELE_ERROR = "FETCH_ATELIERLIGNEMODELE_ERROR"
export const FETCH_ATELIERLIGNEMODELE_SUCCESS =
	"FETCH_ATELIERLIGNEMODELE_SUCCESS"
export const FETCH_ATELIERLIGNEMODELE_RESET = "FETCH_ATELIERLIGNEMODELE_RESET"

export const fetchAtelierLigneModeleBegin = () => ({
	type: FETCH_ATELIERLIGNEMODELE_BEGIN,
})

export const fetchAtelierLigneModeleError = (error) => ({
	type: FETCH_ATELIERLIGNEMODELE_ERROR,
	payload: { error },
})

export const fetchAtelierLigneModeleSuccess = (atelierLigneModele) => ({
	type: FETCH_ATELIERLIGNEMODELE_SUCCESS,
	payload: { atelierLigneModele },
})

export const fetchAtelierLigneModeleReset = () => ({
	type: FETCH_ATELIERLIGNEMODELE_RESET,
})

export function fetchAtelierLigneModele(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAtelierLigneModeleBegin())
		let url = `${URL}api/atelierlignemodele?id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchAtelierLigneModeleSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchAtelierLigneModeleError))
	}
}

export const FETCH_ATELIERCOMMENTAIREMODELE_BEGIN =
	"FETCH_ATELIERCOMMENTAIREMODELE_BEGIN"
export const FETCH_ATELIERCOMMENTAIREMODELE_ERROR =
	"FETCH_ATELIERCOMMENTAIREMODELE_ERROR"
export const FETCH_ATELIERCOMMENTAIREMODELE_SUCCESS =
	"FETCH_ATELIERCOMMENTAIREMODELE_SUCCESS"
export const FETCH_ATELIERCOMMENTAIREMODELE_RESET =
	"FETCH_ATELIERCOMMENTAIREMODELE_RESET"

export const fetchAtelierCommentaireModeleBegin = () => ({
	type: FETCH_ATELIERCOMMENTAIREMODELE_BEGIN,
})

export const fetchAtelierCommentaireModeleError = (error) => ({
	type: FETCH_ATELIERCOMMENTAIREMODELE_ERROR,
	payload: { error },
})

export const fetchAtelierCommentaireModeleSuccess = (
	atelierCommentaireModele,
) => ({
	type: FETCH_ATELIERCOMMENTAIREMODELE_SUCCESS,
	payload: { atelierCommentaireModele },
})

export const fetchAtelierCommentaireModeleReset = () => ({
	type: FETCH_ATELIERCOMMENTAIREMODELE_RESET,
})

export function fetchAtelierCommentaireModele(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAtelierCommentaireModeleBegin())
		let url = `${URL}api/ateliercommentairemodele?id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchAtelierCommentaireModeleSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchAtelierCommentaireModeleError))
	}
}

//////////////////////////////////////////////////////////////
//                      ATELIERMODELE                       //
//////////////////////////////////////////////////////////////

export const FETCH_ATELIERMODELE_BEGIN = "FETCH_ATELIERMODELE_BEGIN"
export const FETCH_ATELIERMODELE_ERROR = "FETCH_ATELIERMODELE_ERROR"
export const FETCH_ATELIERMODELE_SUCCESS = "FETCH_ATELIERMODELE_SUCCESS"
export const FETCH_ATELIERMODELE_RESET = "FETCH_ATELIERMODELE_RESET"

export const FETCH_ATELIERMODELES_BEGIN = "FETCH_ATELIERMODELES_BEGIN"
export const FETCH_ATELIERMODELES_ERROR = "FETCH_ATELIERMODELES_ERROR"
export const FETCH_ATELIERMODELES_SUCCESS = "FETCH_ATELIERMODELES_SUCCESS"
export const FETCH_ATELIERMODELES_RESET = "FETCH_ATELIERMODELES_RESET"

export const fetchAtelierModeleBegin = () => ({
	type: FETCH_ATELIERMODELE_BEGIN,
})

export const fetchAtelierModeleError = (error) => ({
	type: FETCH_ATELIERMODELE_ERROR,
	payload: { error },
})

export const fetchAtelierModeleSuccess = (payload) => ({
	type: FETCH_ATELIERMODELE_SUCCESS,
	payload,
})

export const fetchAtelierModeleReset = () => ({
	type: FETCH_ATELIERMODELE_RESET,
})

export function fetchAtelierModele(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAtelierModeleBegin())
		let url = `${URL}api/ateliermodeles?id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchAtelierModeleSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchAtelierModeleError))
	}
}

export const fetchAtelierModelesBegin = () => ({
	type: FETCH_ATELIERMODELES_BEGIN,
})

export const fetchAtelierModelesError = (error) => ({
	type: FETCH_ATELIERMODELES_ERROR,
	payload: { error },
})

export const fetchAtelierModelesSuccess = (listeAtelierModeles) => ({
	type: FETCH_ATELIERMODELES_SUCCESS,
	payload: { listeAtelierModeles },
})

export const fetchAtelierModelesReset = () => ({
	type: FETCH_ATELIERMODELES_RESET,
})

export function fetchAtelierModeles() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAtelierModelesBegin())
		let url = `${URL}api/ateliermodeles`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchAtelierModelesSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchAtelierModelesError))
	}
}

export const POST_ATELIERMODELE_BEGIN = "POST_ATELIERMODELE_BEGIN"
export const POST_ATELIERMODELE_ERROR = "POST_ATELIERMODELE_ERROR"
export const POST_ATELIERMODELE_SUCCESS = "POST_ATELIERMODELE_SUCCESS"
export const POST_ATELIERMODELE_RESET = "POST_ATELIERMODELE_RESET"
export const POST_ATELIERMODELE_ERRORFIELD = "POST_ATELIERMODELE_ERRORFIELD"

export const postAtelierModeleBegin = () => ({
	type: POST_ATELIERMODELE_BEGIN,
})

export const postAtelierModeleReset = () => ({
	type: POST_ATELIERMODELE_RESET,
})

export const postAtelierModeleError = (error) => ({
	type: POST_ATELIERMODELE_ERROR,
	payload: { error },
})

export const postAtelierModeleSuccess = (payload) => ({
	type: POST_ATELIERMODELE_SUCCESS,
	payload,
})

export const postAtelierModeleErrorField = (errorFields) => ({
	type: POST_ATELIERMODELE_ERRORFIELD,
	payload: { errorFields },
})

export function postAtelierModele(data, del = -1) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postAtelierModeleBegin())
		let url = `${URL}api/ateliermodeles`
		if (del !== -1) url = `${url}?delId=${del}`
		return fetch(url, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postAtelierModeleSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, postAtelierModeleError, { silent: true }))
	}
}

// DELETE_MODELE

export const DELETE_ATELIERMODELE_BEGIN = "DELETE_ATELIERMODELE_BEGIN"
export const DELETE_ATELIERMODELE_SUCCESS = "DELETE_ATELIERMODELE_SUCCESS"
export const DELETE_ATELIERMODELE_ERROR = "DELETE_ATELIERMODELE_ERROR"
export const DELETE_ATELIERMODELE_RESET = "DELETE_ATELIERMODELE_RESET"

export const deleteAtelierModeleBegin = () => ({
	type: DELETE_ATELIERMODELE_BEGIN,
})

export const deleteAtelierModeleSuccess = (listeAtelierModeles) => ({
	type: DELETE_ATELIERMODELE_SUCCESS,
	payload: { listeAtelierModeles },
})

export const deleteAtelierModeleError = (error) => ({
	type: DELETE_ATELIERMODELE_ERROR,
	payload: { error },
})

export const deleteAtelierModeleReset = () => ({
	type: DELETE_ATELIERMODELE_RESET,
})

export function deleteAtelierModele(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteAtelierModeleBegin())
		return fetch(`${URL}api/ateliermodeles`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(deleteAtelierModeleSuccess(json)))
			.catch(catchApiError(dispatch, deleteAtelierModeleError, { silent: true }))
	}
}
